<template>
  <v-toolbar flat>
    <v-toolbar-title
      ><v-btn text @click="$emit('back')"
        ><v-icon>arrow_left</v-icon> Templates</v-btn
      ></v-toolbar-title
    >
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
export default {
  props: ['title']
};
</script>

<style></style>
